import { SvgProps } from "./Form";

export const ArrowRightUpV2 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M11 0H4.99998V1H10.293L0.0214844 11.2715L0.728484 11.9785L11 1.707V7H12V1C12 0.4485 11.5515 0 11 0Z"
      fill="currentColor"
    />
  </svg>
);
